export const signupStyles = (theme) => ({
  root: {
    height: '100%',
    display: 'flex',
  },
  leftWrapper: {
    backgroundColor: '#FFFFFF',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: 'url("images/auth_bg.jpg")',
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: 'none',
      backgroundColor: '#f3f3f3',
    },
  },
  rightWrapper: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url("images/auth_bg.jpg")',
    height: '100%',
  },
  container: {
    height: '100%',
    display: 'flex',
  },
  panel: {
    margin: '20px 0',
    padding: '30px 60px',
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },
  loginWrapper: {
    textAlign: 'center',
  },
  loginLink: {
    textDecoration: 'none',
  },
  loginMessage: {
    color: theme.palette.primary.main,
    fontFamily: 'FSEmeric-Medium',
    marginLeft: 4,
    '&:hover': { textDecoration: 'underline' },
  },
})
